import { render, staticRenderFns } from "./SmsSendStep.vue?vue&type=template&id=37c13946&scoped=true"
import script from "./SmsSendStep.vue?vue&type=script&lang=js"
export * from "./SmsSendStep.vue?vue&type=script&lang=js"
import style0 from "./SmsSendStep.vue?vue&type=style&index=0&id=37c13946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c13946",
  null
  
)

export default component.exports